import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import BLDWebsiteCategorySortBy from "./BLDWebsiteCategorySortBy";
import { colors } from "../../../../../../../../../assets/styles/tokens";

const BLDWebsiteCategoryFilter = () => {
  return (
    <>
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        mt={1}
        mb={2} 
      >
        <Typography mr={1.5} variant="body1" sx={{color:colors.GrayLightMode[900].$value}}>By Metrics Category</Typography>
        <BLDWebsiteCategorySortBy />
      </Stack>
    </>
  );
};

export default BLDWebsiteCategoryFilter;
